const actions = {
  // Scopes Actions
  GET_SCOPES: 'RBAC/SCOPES/GET_SCOPES',
  GET_SCOPES_SUCCESS: 'RBAC/SCOPES/GET_SCOPES_SUCCESS',
  GET_SCOPES_ERROR: 'RBAC/SCOPES/GET_SCOPES_ERROR',
  CREATE_SCOPE: 'RBAC/SCOPES/CREATE_SCOPE',
  CREATE_SCOPE_SUCCESS: 'RBAC/SCOPES/CREATE_SCOPE_SUCCESS',
  CREATE_SCOPE_ERROR: 'RBAC/SCOPES/CREATE_SCOPE_ERROR',
  UPDATE_SCOPE: 'RBAC/SCOPES/UPDATE_SCOPE',
  UPDATE_SCOPE_SUCCESS: 'RBAC/SCOPES/UPDATE_SCOPE_SUCCESS',
  UPDATE_SCOPE_ERROR: 'RBAC/SCOPES/UPDATE_SCOPE_ERROR',
  DELETE_SCOPE: 'RBAC/SCOPES/DELETE_SCOPE',
  DELETE_SCOPE_SUCCESS: 'RBAC/SCOPES/DELETE_SCOPE_SUCCESS',
  DELETE_SCOPE_ERROR: 'RBAC/SCOPES/DELETE_SCOPE_ERROR',
  CLEAR_SCOPES_ERROR: 'RBAC/SCOPES/CLEAR_SCOPES_ERROR',

  // Action Creators
  getScopes: () => ({
    type: actions.GET_SCOPES,
  }),
  getScopesSuccess: (scopes) => ({
    type: actions.GET_SCOPES_SUCCESS,
    scopes,
  }),
  getScopesError: (error) => ({
    type: actions.GET_SCOPES_ERROR,
    error,
  }),
  createScope: (scopeData) => ({
    type: actions.CREATE_SCOPE,
    scopeData,
  }),
  createScopeSuccess: (scope) => ({
    type: actions.CREATE_SCOPE_SUCCESS,
    scope,
  }),
  createScopeError: (error) => ({
    type: actions.CREATE_SCOPE_ERROR,
    error,
  }),
  updateScope: (scopeId, scopeData) => ({
    type: actions.UPDATE_SCOPE,
    scopeId,
    scopeData,
  }),
  updateScopeSuccess: (scope) => ({
    type: actions.UPDATE_SCOPE_SUCCESS,
    scope,
  }),
  updateScopeError: (error) => ({
    type: actions.UPDATE_SCOPE_ERROR,
    error,
  }),
  deleteScope: (scopeId) => ({
    type: actions.DELETE_SCOPE,
    scopeId,
  }),
  deleteScopeSuccess: (scopeId) => ({
    type: actions.DELETE_SCOPE_SUCCESS,
    scopeId,
  }),
  deleteScopeError: (error) => ({
    type: actions.DELETE_SCOPE_ERROR,
    error,
  }),
  clearScopesError: () => ({
    type: actions.CLEAR_SCOPES_ERROR,
  }),
};

export default actions;
